import { Component, computed, inject, input } from '@angular/core';

import { ConfigStore } from '@stores/index';

export type EmptyStateModel =
  | 'list'
  | 'merchant'
  | 'product'
  | 'service'
  | 'permission'
  | 'other';

@Component({
  selector: 'empty-state',
  imports: [],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
})
export class EmptyStateComponent {
  private configStore = inject(ConfigStore);

  readonly searchTerm = input('');
  readonly searchType = input<EmptyStateModel>('service');
  readonly imageClass = input('');
  readonly messageClass = input('');

  theme = computed(() => this.configStore.getConfig()?.activeMode);
}
